export const PLATFORMS = {
  EXTENSION: 0,
  MOBILE: 1
}

export const PLATFORM_OPTIONS = [
  { value: PLATFORMS.EXTENSION, label: 'Extension' },
  { value: PLATFORMS.MOBILE, label: 'Mobile' }
]

export const getPlatformName = (value) => {
  return value === PLATFORMS.EXTENSION ? 'Extension' : 'Mobile'
}

// Image upload configuration
export const IMAGE_CONFIG = {
  icon: {
    name: 'Icon',
    maxSize: 2 * 1024 * 1024, // 2MB
    defaultDimensions: { width: 150, height: 150 },
    previewSize: { width: 150, height: 150 },
    clearAttribute: 'clear_icon_image',
    fileStateKey: 'iconFile',
    previewStateKey: 'iconPreview',
    uploadingStateKey: 'isUploadingIcon'
  },
  hero: {
    name: 'Hero Image',
    maxSize: 2 * 1024 * 1024, // 2MB
    defaultDimensions: { width: 600, height: 400 },
    previewSize: { width: 200, height: 133 },
    clearAttribute: 'clear_hero_image',
    fileStateKey: 'heroFile',
    previewStateKey: 'heroPreview',
    uploadingStateKey: 'isUploadingHero'
  },
  logoIcon: {
    name: 'Logo Icon',
    maxSize: 2 * 1024 * 1024, // 2MB
    defaultDimensions: { width: 120, height: 34 },
    previewSize: { width: 120, height: 34 },
    clearAttribute: 'clear_logo_icon_image',
    fileStateKey: 'logoIconFile',
    previewStateKey: 'logoIconPreview',
    uploadingStateKey: 'isUploadingLogoIcon'
  }
}

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif']